/**
 * Store related to externally saved data
 */
export const useSavedStateStore = defineStore('savedState', () => {
  const data = ref<OwnbitConfigurator.AggregateStorableState | undefined>()

  return {
    load(savedData: OwnbitConfigurator.AggregateStorableState | undefined) {
      data.value = savedData
    },
    get<T extends keyof OwnbitConfigurator.AggregateStorableState, U = undefined>(
      key: T,
      fallback: U = undefined as U,
    ): NonNullable<OwnbitConfigurator.AggregateStorableState[T]> | U {
      return data.value?.[key] ?? fallback
    },
    data: readonly(data),
  }
})
